import { Checkbox, CheckboxProps } from '@vtex/admin-ui'
import { styles } from './styles'
import { DefaultProps } from 'typings'

export function CollapsibleCheckbox(props: CheckboxProps & DefaultProps) {
  const { state, children, ...rest } = props

  return (
    <div className={styles.container}>
      <Checkbox state={state} {...rest} />
      {state?.value && <div className={styles.nestedContainer}>{children}</div>}
    </div>
  )
}
